<template>
  <v-dialog max-width="1000px" persistent v-model="dialog" scrollable>
    <v-card v-if="selectedCustomer != null && selectedCustomer.user_address" disabled>
      <v-toolbar dark>
        <v-toolbar-title class="headline">Address management</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="$emit('setDialog',false) && $emit('cancel')">close</v-icon>
      </v-toolbar>

      <v-card-text class="pt-0" style="height:auto;">
        <v-layout row wrap>
          <v-flex sm12 md6 class="pr-2">
            <addressListDetail
              v-for="(row,index) in selectedCustomer.user_address"
              :key="index"
              :info="row"
              :selectedCustomer="selectedCustomer"
            />
          </v-flex>
          <v-flex sm12 md6 class="pl-2">
            <newAddressForm :selectedCustomer="selectedCustomer" />
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import addressListDetail from "./AddressListDetail";
import newAddressForm from "./NewAddressForm";
import { mapGetters } from "vuex";
export default {
  props: ["dialog", "selectedCustomer"],
  data() {
    return {
      showAddForm: false
    };
  },
  components: {
    addressListDetail,
    newAddressForm
  },
  computed: {
    ...mapGetters(["isEditCustomer"])
  }
};
</script>

<style>
</style>
